import React from "react";

const PendingServicesComponent = (props) => {
    return (
        <>
            <div className="row justify-content-center h-100 align-items-center pt-5">
                <div className="col-md-5">
                    <div className="form-input-content text-center error-page">
                        {/* <h1 className="error-text  font-weight-bold">403</h1> */}
                        <h4><i className="fa fa-times-circle text-danger"></i>{props.context.t("DASHBOARD-Hello.Service.Not.Found")}</h4>
                        {/* <p>Service not currently enabled</p> */}
                        <div>
                            <a className="btn btn-primary" href="#/dashboard">{props.context.t("DASHBOARD-Hello.Back.To.Home")}</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PendingServicesComponent;